export default __webpack_public_path__ + "static/media/work12.90510fe0.svg";